import {
  mapVenueOverviewVersionType,
  PermissionNameUnionType,
  useFindVenueOverviewVersionSuspense,
} from '@api';
import {
  EditActionIcon,
  TouringCard,
  TouringCardActions,
  TouringCardHeader,
  TouringCardSection,
  TouringCardTitle,
} from '@common';
import { usePermissionContext } from '@hypeit-gmbh/hypeit-ui-core';
import { Modal } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useTranslation } from 'react-i18next';
import { Route } from 'src/routes/_rootLayout/venues/$id.overview.$version';
import { VenueCompsForm, VenueCompsTable } from './components';

export const VenueComps: React.FC = () => {
  const { t } = useTranslation('venueDetailsOverview');
  const [opened, { open: openModal, close: closeModal }] = useDisclosure(false);
  const { id, version } = Route.useParams();
  const { data: overviewVersion } = useFindVenueOverviewVersionSuspense(
    id,
    version,
    {
      query: {
        select: (data) => mapVenueOverviewVersionType(data.data),
      },
    }
  );
  const { hasPermission } = usePermissionContext<PermissionNameUnionType>();

  const userCanEditVenueComps = hasPermission({
    permission: 'VENUES_OVERVIEW',
    action: 'WRITE',
  });

  return (
    <>
      <TouringCard data-testid="venue-comps">
        <TouringCardHeader>
          <TouringCardTitle>{t('VENUE_COMPS.TITLE')}</TouringCardTitle>
          <TouringCardActions>
            {userCanEditVenueComps && <EditActionIcon onClick={openModal} />}
          </TouringCardActions>
        </TouringCardHeader>
        <TouringCardSection>
          <VenueCompsTable venueComps={overviewVersion.venueComps} />
        </TouringCardSection>
      </TouringCard>
      <Modal
        opened={opened}
        onClose={closeModal}
        title={t('VENUE_COMPS.EDIT_MODAL_TITLE')}
      >
        <VenueCompsForm
          venueId={id}
          overviewVersion={version}
          venueComps={overviewVersion.venueComps}
          onClose={closeModal}
        />
      </Modal>
    </>
  );
};
